import type { AcademySport, Lesson } from '@court-sync/shared';
import { isMultiSportAcademy, resolveLessonSport } from '@/lib/sportPresentation';
import { SportGlyph } from './SportGlyph';
import type { SportIconVariant } from './SportIcons';

/** Small sport icon on calendar chips when the academy runs multiple sports. */
export function CalendarChipSportGlyph({
  lesson,
  academySports,
  enabled,
  variant = 'light',
  className = 'h-2.5 w-2.5 shrink-0',
}: {
  lesson: Pick<Lesson, 'academySportId'>;
  academySports: readonly AcademySport[];
  /** Parent already gates multi-sport; keep false when sport glyphs are off for the view. */
  enabled: boolean;
  /** Use `light` on solid month chips (light text); `dark` on soft weekly slot tints. */
  variant?: SportIconVariant;
  className?: string;
}) {
  if (!enabled || !isMultiSportAcademy(academySports)) return null;
  const presentation = resolveLessonSport(lesson, academySports);
  return <SportGlyph sportId={presentation.sportId} className={className} variant={variant} />;
}
